import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="extension-version" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static String extensionVersion()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`final String lifecycleExtensionVersion = Lifecycle.extensionVersion();
`}</code></pre>
    <Variant platform="ios" api="extension-version" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static var extensionVersion: String
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let version = Lifecycle.extensionVersion
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc static var extensionVersion: String
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`NSString *version = [AEPMobileLifecycle extensionVersion];
`}</code></pre>
    {/*- <Variant platform="react-native" api="extension-version" repeat="2"/>
     **JavaScript**
     ```jsx
     ACPLifecycle.extensionVersion().then(lifecycleExtensionVersion => console.log("AdobeExperienceSDK: ACPLifecycle version: " + lifecycleExtensionVersion));
     ```
     <Variant platform="flutter" api="extension-version" repeat="2"/>
     **Dart**
     ```dart
     String lifeycycleExtensionVersion = await FlutterACPLifecycle.extensionVersion;
     ``` -*/}
    <Variant platform="android" api="lifecycle-start" repeat="8" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p>{`This method should be called from the Activity onResume method.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void lifecycleStart(@Nullable final Map<String, String> additionalContextData)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.lifecycleStart(null);
`}</code></pre>
    <p>{`If you need to collect additional lifecycle data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`contextData.put("myapp.category", "Game");
MobileCore.lifecycleStart(additionalContextData);
`}</code></pre>
    <Variant platform="ios" api="lifecycle-start" repeat="14" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` static func lifecycleStart(additionalContextData: [String: Any]?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.lifecycleStart(additionalContextData: nil)
`}</code></pre>
    <p>{`If you need to collect additional lifecycle data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.lifecycleStart(additionalContextData: ["contextDataKey": "contextDataVal"])
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` @objc(lifecycleStart:)
 static func lifecycleStart(additionalContextData: [String: Any]?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` [AEPMobileCore lifecycleStart:nil];
`}</code></pre>
    <p>{`If you need to collect additional lifecycle data:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` [AEPMobileCore lifecycleStart:@{@"contextDataKey": @"contextDataVal"}];
`}</code></pre>
    {/*- <Variant platform="react-native" api="lifecycle-start" repeat="2"/>
     #### JavaScript
     When using React Native, starting to collect lifecycle data should be done in native code which is shown under the Android and iOS (ACP 2.x) tabs. -*/}
    <Variant platform="android" api="lifecycle-pause" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-2"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void lifecyclePause()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.lifecyclePause();
`}</code></pre>
    <Variant platform="ios" api="lifecycle-pause" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` static func lifecyclePause()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.lifecyclePause()
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` @objc(lifecyclePause)
 static func lifecyclePause()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` [AEPMobileCore lifecyclePause];
`}</code></pre>
    {/*- <Variant platform="react-native" api="lifecycle-pause" repeat="2"/>
     #### JavaScript
     When using React Native, pausing the collection of lifecycle data should be done in native code which is shown under the Android and iOS (ACP 2.x) tabs. -*/}
    <Variant platform="android" api="register-extension" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-3"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void registerExtension()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Lifecycle.registerExtension();


export const _frontmatter = {}
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      